import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import PaystackRedirect from '@/components/layout/PaystackRedirect.tsx';

const PaymentPage: FC = () => {
  const location = useLocation();
  const redirectUrl = location.state.redirectUrl || '';

  return <PaystackRedirect redirectUrl={redirectUrl} />;
};

export default PaymentPage;
